const DB_NAME = 'checkups_offline_v1';
const DB_VERSION = 1;
let _db = null;

function openDb() {
  if (_db) return Promise.resolve(_db);
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains('networks')) {
        db.createObjectStore('networks', { keyPath: 'id' });
      }
      if (!db.objectStoreNames.contains('poles')) {
        const s = db.createObjectStore('poles', { keyPath: 'id' });
        s.createIndex('by_network', 'network_id');
      }
      if (!db.objectStoreNames.contains('outbox')) {
        db.createObjectStore('outbox', { keyPath: 'client_id' });
      }
    };
    req.onsuccess = (e) => { _db = e.target.result; resolve(_db); };
    req.onerror = () => reject(req.error);
  });
}

function idbReq(req) {
  return new Promise((res, rej) => {
    req.onsuccess = () => res(req.result);
    req.onerror = () => rej(req.error);
  });
}

function idbTxWrite(db, storeName, fn) {
  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, 'readwrite');
    tx.oncomplete = resolve;
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error);
    fn(tx.objectStore(storeName));
  });
}

// Networks
export async function saveNetworks(list) {
  const db = await openDb();
  const now = Date.now();
  return idbTxWrite(db, 'networks', (store) => {
    list.forEach((n) => store.put({ ...n, _cached_at: now }));
  });
}

export async function getCachedNetworks() {
  const db = await openDb();
  const tx = db.transaction('networks', 'readonly');
  return idbReq(tx.objectStore('networks').getAll());
}

// Poles
export async function savePoles(list) {
  const db = await openDb();
  const now = Date.now();
  return idbTxWrite(db, 'poles', (store) => {
    list.forEach((p) => store.put({ ...p, _cached_at: now }));
  });
}

export async function getCachedPoles(networkId) {
  const db = await openDb();
  const tx = db.transaction('poles', 'readonly');
  return idbReq(tx.objectStore('poles').index('by_network').getAll(Number(networkId)));
}

export async function getCachedPolesUpdatedAt(networkId) {
  const poles = await getCachedPoles(networkId);
  if (!poles.length) return null;
  return Math.max(...poles.map((p) => p._cached_at || 0));
}

// Outbox
export async function addToOutbox(entry) {
  const db = await openDb();
  return idbTxWrite(db, 'outbox', (store) => {
    store.put({
      status: 'pending',
      retry_count: 0,
      last_error: null,
      created_at: Date.now(),
      ...entry,
    });
  });
}

export async function getAllOutbox() {
  const db = await openDb();
  const tx = db.transaction('outbox', 'readonly');
  return idbReq(tx.objectStore('outbox').getAll());
}

export async function getPendingOutbox() {
  const all = await getAllOutbox();
  return all
    .filter((e) => e.status === 'pending' || e.status === 'sending' || e.status === 'failed')
    .sort((a, b) => a.created_at - b.created_at);
}

export async function updateOutbox(client_id, changes) {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction('outbox', 'readwrite');
    const store = tx.objectStore('outbox');
    const getReq = store.get(client_id);
    getReq.onsuccess = () => {
      if (getReq.result) store.put({ ...getReq.result, ...changes });
    };
    getReq.onerror = () => reject(getReq.error);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

export async function removeFromOutbox(client_id) {
  const db = await openDb();
  return idbTxWrite(db, 'outbox', (store) => store.delete(client_id));
}

export async function countPendingOutbox() {
  const all = await getAllOutbox();
  return all.length;
}
